import styled from 'styled-components';

import { heading3 } from 'styles/mixins/fonts';
import { EllipsisText } from 'components/ellipsis-text';

export const Title = styled(EllipsisText)`
  ${heading3};
`;
